import React, { Component } from "react";
import { observer } from "mobx-react";
import {Button, Input, Modal, Popover, Spin, Tabs, Tooltip,DatePicker} from "antd";
import { Web3Store } from "../stores/web3Store";
import MythCard from "../components/mythCard"
import { RouteComponentProps } from "react-router";
import golden from "../images/golden.webp";
import classic from "../images/silver.webp";
import { CheckCircleFilled, CloseCircleFilled, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import "../styles/freeMintPage.less"
import { getMythNFTSConfig } from "../env";
import { IAction, IGetAllConfigResponse, IMythServerResponse } from "../bean/ResponseBean";
import logger from "../logger";
import { ActionStatus, MythActionType, UserActionStatus } from "../constant/MythAction";
import { formatTime, toOpensea } from "../utils/commonUtils";
import { ApplyForFreeMintBtn } from "../components/applyCard/freeMintBtn";
import { RootStore } from "../stores/rootStore";
import { MintBtn } from "../components/applyCard/mintBtn";
import { withRouter } from "react-router-dom";
import FreeMintPageUpcomingTimer from "../components/freeMintList/freeMintPageUpcomingTimer";
import { NoConnectedWallet } from "../components/noConnected/noConnectedWallet";
import { utils as ethersUtils } from "ethers/lib/ethers";
import { ErrorWithMessage, toErrorWithMessage } from "../utils/error";
import { ResultModal } from "../components/mythPASSModal";
import { GOLDEN_PRICE } from "../constant/CommonConstant";
import moment from "moment";
const { RangePicker } = DatePicker;

interface IProps extends RouteComponentProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}
interface IStates {
    actionId: number;
    activeMenu: IAction;
    themeId: number,
    themeName:string
    nftTypeId: number,
    contractAddress: string,
    quantity: number,
    actionJoinedPass: number[],
    isClaimed: boolean,
    actionLoading: boolean,
    whitelistList: string[],
    address: string,
    buyNum: number,
    userActionStatus:string,
    remainSellTokensNumber: number,
    remainMintTokensNumber: number,
    isInWhiteList: boolean,
    buyButtonLoading: boolean,
    buyResultVisible: boolean,
    publicSaleLoading: boolean,
}

@observer
class FreeMintPage extends Component<IProps, IStates> {
    private firstRequest: boolean = false;
    constructor(props: IProps, state: IStates) {
        super(props);
        let locationState: any = this.props.location.state;
        const actionId = locationState.actionId;
        this.state = {
            actionId: actionId,
            themeId: 0,
            themeName:"",
            nftTypeId: 0,
            contractAddress: "",
            quantity: 0,
            userActionStatus:UserActionStatus.ACTION_UNSTARTED,
            activeMenu: {
                id: -1,
                actionId: 0,
                actionName: "Classic PASS Access",
                actionImageUrl: "apply1",
                iconUrl: "",
                thumbnail_url: "",
                startTime: "",
                endTime: "",
                isEnd: false,
                actionType: 1,
                status: 0,
                description: "",
                smallTitle: "",
                applyEndTime: '',
                mintEndTime: '',
                sortWeight: 0,
                themeId: 0,
                nftTypeId: 0,
            },
            actionJoinedPass: [],
            isClaimed: false,
            actionLoading: true,
            whitelistList: [],
            address: "",
            buyNum: 1,
            remainSellTokensNumber: 1,
            remainMintTokensNumber: 1,
            isInWhiteList: false,
            buyButtonLoading: false,
            buyResultVisible: false,
            publicSaleLoading: false
        };
    }

    gotoContract = ()=>{
        const {contractAddress} = this.state
        window.open("https://etherscan.io/token/"+contractAddress);
    }
    gotoMarket = ()=> {
        const {themeId} = this.state
        if (themeId === 1) {
            window.open(" https://opensea.io/zh-CN/collection/crypto-heroes-wexckdbugm");
        } else if(themeId === 2){
            window.open("https://opensea.io/zh-CN/collection/shan-hai-jing-v3");
        }
    }

    /**
     * 获取某个活动的信息
     * @param actionId
     */
    async requestActionInfo(actionId: number) {
        const { web3Store } = this.props;
        try {
            if (web3Store.mythServerApi && web3Store.account && web3Store.chain) {
                let response: IMythServerResponse<IGetAllConfigResponse> = await web3Store.mythServerApi.getAllConfig(actionId, web3Store.account);
                let themeId: number = -1, nftTypeId: number = -1, contractAddress: string = "",themeName="";
                let activeMenu = response.resultValue.actionInfo;
                themeId = activeMenu.themeId;
                nftTypeId = activeMenu.nftTypeId;
                getMythNFTSConfig().forEach(value => {
                    if (value.theme.themeId === themeId) {
                        contractAddress = value.theme.contractAddr;
                        themeName = value.theme.name
                    }
                });
                const isClaimed = await this.getUserClaimed(contractAddress, nftTypeId)
                const result: number[] = await this.getRemainToken(contractAddress, nftTypeId)
                this.setState({
                    themeId: themeId,
                    themeName: themeName,
                    nftTypeId: nftTypeId,
                    contractAddress: contractAddress,
                    quantity: Math.floor(result[0] / 2) * 2,
                    isClaimed: isClaimed,
                    remainSellTokensNumber: result[1],
                    remainMintTokensNumber: result[2],
                    activeMenu: activeMenu
                });

                let isInWhitelist: boolean = false;
                response.resultValue.getWinningListResponse.winningList.forEach(value => {
                    if (value.toLowerCase() === web3Store.account.toLowerCase()) {
                        isInWhitelist = true;
                    }
                })
                this.setState({
                    actionJoinedPass: response.resultValue.actionPassTokenIds,
                    whitelistList: response.resultValue.getWinningListResponse.winningList,
                    isInWhiteList: isInWhitelist,
                    actionLoading: false,
                    userActionStatus:response.resultValue.userActionStatus,
                })
                this.firstRequest = true;
            }
        } catch (ex: any) {
            logger.error(ex);
        }
    }


    async refreshPublicSale() {
        const { nftTypeId, contractAddress } = this.state
        this.setState({
            publicSaleLoading: true
        });
        try {
            const result: number[] = await this.getRemainToken(contractAddress, nftTypeId)
            this.setState({
                remainSellTokensNumber: result[1],
                publicSaleLoading: false
            });
        } catch (e) {
            this.setState({
                publicSaleLoading: true
            });
            logger.error(e);
        }
    }

    /**
     * 从合约中获取账号是否领取的状态
     * @param contractAddress
     * @param nftTypeId
     */
    async getUserClaimed(contractAddress: string, nftTypeId: number): Promise<boolean> {
        const { web3Store } = this.props;
        let isClaimed = false;
        try {
            if (web3Store && web3Store.mythNFTManager && contractAddress && web3Store.account) {
                isClaimed = await web3Store.mythNFTManager.nftClaimed(contractAddress, nftTypeId, web3Store.account)
            }
        } catch (ex) {
            logger.error(ex);
        }
        return isClaimed
    }

    /**
     * 从合约中获取某一个系列活动的剩余购买token数量
     * @param contractAddress
     * @param nftTypeId
     */
    async getRemainToken(contractAddress: string, nftTypeId: number): Promise<number[]> {
        const { web3Store } = this.props;
        const { activeMenu } = this.state;
        let remainSellTokensNumber = 0;
        let remainMintTokensNumber = 0;
        let quantity = 100;
        try {
            if (web3Store && web3Store.mythNFTManager) {
                const nft = await web3Store.mythNFTManager.nfts(contractAddress, nftTypeId)
                if(activeMenu.actionType === MythActionType.TYPE_CLASSIC || activeMenu.actionType === MythActionType.TYPE_WHITE){
                    remainSellTokensNumber = 0;
                    remainMintTokensNumber = nft.endTokenId - nft.tokenId + 1;
                }
                if(activeMenu.actionType === MythActionType.TYPE_GOLDEN){
                    remainSellTokensNumber = Math.floor(nft.totalNum / 2) - nft.soldNum;
                    remainMintTokensNumber = Math.max(0,nft.endTokenId - nft.tokenId + 1 - remainSellTokensNumber);
                }
                quantity = nft.totalNum;
            }

        } catch (ex) {
            logger.error(ex);
        }
        return [quantity, remainSellTokensNumber, remainMintTokensNumber];
    }

    renderRequirements = () => {
        const { activeMenu } = this.state;
        return <div>
            {activeMenu.actionType === MythActionType.TYPE_WHITE ?
                <MythCard title="Requirements" className="requirement-card">
                    <p>Everyone who completes our Gleam campaign co-launched by MythArt and Doodle Duckling will automatically win a Duckville Poor Party badge OAT. We will pick 200 lucky members for a free mint of Myth Classic PASS and free mint of Doodle Duckling PFP NFT.</p>
                </MythCard> :
                <MythCard title="Requirements" className="requirement-card">
                    <>
                        {activeMenu.actionType === MythActionType.TYPE_CLASSIC ? <p>You can participate in the NFT's Free-Mint by verifying either the Classic PASS or the Golden PASS</p> :
                            <p>You can participate in the NFT's Free-Mint by verifying Golden PASS</p>}
                        <Tooltip title="MythArt Golden PASS">
                            <img src={golden} alt="" className="requirement-img" />
                        </Tooltip>
                        {activeMenu.actionType === MythActionType.TYPE_CLASSIC && <Tooltip title="MythArt Classic PASS">
                            <img src={classic} alt="" className="requirement-img" />
                        </Tooltip>}
                    </>
                </MythCard>
            }
        </div>
    }

    renderPeriod = () => {
        const dateFormat = 'YYYY-MM-DD';
        const { activeMenu } = this.state;
        return <MythCard title="Period" className="period-card" more={<RangePicker inputReadOnly={true} defaultValue={[moment(activeMenu.startTime, dateFormat), moment(activeMenu.mintEndTime, dateFormat)]} disabledDate={(current: any)=>{return true}}/>}>
            <>
                {activeMenu.actionType !== MythActionType.TYPE_WHITE && <p><span className="period-label">Register</span><span>{activeMenu.startTime} - {activeMenu.applyEndTime}</span></p>}
                <p><span className="period-label">Claimable</span><span>{activeMenu.applyEndTime} - {activeMenu.mintEndTime}</span></p>
            </>
        </MythCard>
    }
    inputCount = (event: any) => {
        const { remainSellTokensNumber } = this.state;
        let value = event.target.value;
        const regExp = /^[0-9]\d*$/;
        if (value === '') {
            value = '0';
        }
        if (!regExp.test(value)) {
            return;
        }
        const num = Number.parseInt(value);
        if (num > remainSellTokensNumber) {
            return;
        }
        this.setState({
            buyNum: num
        })
    };

    changeBuyNum = (input: number) => {
        const { remainSellTokensNumber, buyNum } = this.state;
        const num = buyNum + input;
        if (num > remainSellTokensNumber || num < 1) {
            return;
        }
        this.setState({
            buyNum: num
        })
    };
    onError = (err: ErrorWithMessage) => {
        Modal.error({
            title: "Transaction Error",
            content: err.message,
        });
    };
    onApplySuccessfully = (activeMenu: IAction) => {
        window.location.reload()
    }

    buyDirectly = async () => {
        const { web3Store } = this.props
        const { buyNum, contractAddress, nftTypeId } = this.state
        this.setState({
            buyButtonLoading: true
        })
        if (web3Store && web3Store.mythNFTManager) {
            try {
                const value = ethersUtils.parseUnits((buyNum * GOLDEN_PRICE).toFixed(5), 18);
                const tx = await web3Store.mythNFTManager.buyNFT(contractAddress, nftTypeId, buyNum, {
                    value: value,
                });
                await tx.wait();
                this.setState({
                    buyButtonLoading: false,
                    buyResultVisible: true
                })
            } catch (e) {
                logger.error(e);
                this.setState({
                    buyButtonLoading: false
                })
                this.onError(toErrorWithMessage(e));
            }
        }

    };
    toMyNFT = (account: string) => {
        toOpensea(account)
        window.location.reload()
    };

    renderResult = () => {
        const { web3Store } = this.props
        const text = <>Congratulations! < br /> Minted successfully!</>
        const content = <>
            <Button className='myth-button nft-btn'
                onClick={() => this.toMyNFT(web3Store.account)}>My NFT Collections</Button>
        </>
        return <ResultModal success={true} visible={this.state.buyResultVisible} onCancel={() => {
            window.location.reload();
        }} content={content} text={text} />
    };
    renderPassHolder = () => {
        const { quantity, activeMenu, actionJoinedPass, nftTypeId, contractAddress, themeId, whitelistList, remainMintTokensNumber,isClaimed,userActionStatus } = this.state
        const { web3Store } = this.props
        let userActionStatusResult= userActionStatus
        //服务端返回是否领取判断不准确，需要前端判断
        if (userActionStatus === UserActionStatus.PASS_MODE_APPLY_SUCCESS_UNMINT || userActionStatusResult === UserActionStatus.PASS_MODE_APPLY_SUCCESS_MINTED) {
            if (isClaimed) {
                userActionStatusResult = UserActionStatus.PASS_MODE_APPLY_SUCCESS_MINTED
            } else {
                userActionStatusResult = UserActionStatus.PASS_MODE_APPLY_SUCCESS_UNMINT
            }
        }
        if (userActionStatus === UserActionStatus.WHITE_MODE_CLAIMED || userActionStatusResult === UserActionStatus.WHITE_MODE_CLAIMABLE) {
            if (isClaimed) {
                userActionStatusResult = UserActionStatus.WHITE_MODE_CLAIMED
            } else {
                userActionStatusResult = UserActionStatus.WHITE_MODE_CLAIMABLE
            }
        }
        let btnMint;
        if (userActionStatusResult === UserActionStatus.ACTION_UNSTARTED) {//活动未开始
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully}
                                         btnDisabled={true} btnContent={"Register"} />
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.WHITE_MODE_NO_ELIGIBLE) {//白名单模式未在白名单
            //在白名单地方处理
        } else if (userActionStatusResult === UserActionStatus.WHITE_MODE_CLAIMABLE) {//白名单模式在白名单未领取
            //在白名单地方处理
        } else if (userActionStatusResult === UserActionStatus.WHITE_MODE_CLAIMED) {//白名单模式在白名单且已领取
            //在在白名单地方处理
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_APPLYABLE) {//PASS模式，活动在申请打新阶段，用户未申请打新
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={false} btnContent={"Register"} />
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_APPLYED) {//PASS模式，活动在申请打新阶段，用户已经申请打新
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true} btnContent={"Registered"}/>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_LOTTERY_NOT_APPLIED) {//PASS模式，活动在等待中签结果阶段，用户未申请打新
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true}  btnContent={"Registration closed"}/>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_LOTTERY_APPLIED) {//PASS模式，活动在等待中签结果阶段，用户已申请打新等待打新结果
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true} btnContent={"Registered"}/>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_APPLY_SUCCESS_UNMINT) {//PASS模式，活动已确定中签结果阶段，用户中签未领取
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true} btnContent={"Registered"} />
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> View Qualification</span>
                    <Button className={"myth-button myth-button-success"} style={{width:"5.5rem"}}>You are selected！</Button>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={false} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_APPLY_SUCCESS_MINTED) {//PASS模式，活动已确定中签结果阶段，用户中签已领取
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true}  btnContent={"Registered"} />
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> View Qualification</span>
                    <Button style={{width:"5.5rem"}} className={"myth-button myth-button-success"}>You are selected！</Button>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claimed"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_APPLY_FAILED) {//PASS模式，活动已确定中签结果阶段，用户未中签
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true} btnContent={"Registered"} />
                </li>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> View Qualification</span>
                    <Button disabled={true}  style={{width:"5.5rem"}}  className={"myth-button myth-button-success"}>You Lost</Button>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.PASS_MODE_APPLY_FAILED_NOT_APPLY) {//PASS模式，活动已确定中签结果阶段，用户未申请打新
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true} btnContent={"Registration closed"}/>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        } else if (userActionStatusResult === UserActionStatus.ACTION_EXPIRED) {//活动领取已过期
            btnMint = <ul>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> Apply For Minting</span>
                    <ApplyForFreeMintBtn activeMenu={activeMenu} web3Store={web3Store}
                                         actionJoinedPass={actionJoinedPass}
                                         isGolden={activeMenu.actionType === MythActionType.TYPE_GOLDEN}
                                         quantity={quantity} onApplySuccessfully={this.onApplySuccessfully} btnDisabled={true} btnContent={"Register"} />
                </li>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> View Qualification</span>
                    <span>ENDS IN <FreeMintPageUpcomingTimer countTime={formatTime(activeMenu.applyEndTime)} /></span>
                </li>
                <li className="list-item flex-row space-between">
                    <span><CloseCircleFilled className="list-icon list-icon-danger" /> Claim Your Free NFT</span>
                    <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                             contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
                </li>
            </ul>
        }
        return <MythCard title={activeMenu.actionType === MythActionType.TYPE_GOLDEN ? `${remainMintTokensNumber}/${quantity / 2} for MythPASS Holder` :
            activeMenu.actionType === MythActionType.TYPE_CLASSIC ? `${remainMintTokensNumber}/${quantity} for MythPASS Holder` : ""}
            className="holder-card" >
            <>{btnMint}</>
        </MythCard>
    }
    renderPublicSale = () => {
        const { quantity, buyButtonLoading, remainSellTokensNumber, publicSaleLoading } = this.state
        return <MythCard title={`${remainSellTokensNumber}/${quantity / 2} for Public Sale`} className="sale-card" more={<i className="iconfont icon-reload" onClick={() => { this.refreshPublicSale() }}></i>} titleLoading={publicSaleLoading}>
            <div className="sale-container flex-row space-between">
                <span>{GOLDEN_PRICE}ETH FOR 1NFT</span>
                <div className="input-container">
                    <span><MinusOutlined className="buy-icon" onClick={() => this.changeBuyNum(-1)} />
                        <Input value={this.state.buyNum} onChange={(e) => this.inputCount(e)} defaultValue={1} className="buy-input" />
                        <PlusOutlined className="buy-icon" onClick={() => this.changeBuyNum(1)} /></span>
                    <Button className="myth-button" loading={buyButtonLoading} onClick={this.buyDirectly}>Buy Directly</Button>
                </div>
            </div>
        </MythCard>
    }
    renderNFTINFO = () => {
        const { activeMenu } = this.state
        if(activeMenu.actionType !== MythActionType.TYPE_GOLDEN) {
            return <><p>Chain:Ethereum</p>
                <p>Rarity:Golden</p>
                <p>Total Supply:100</p>
                <p>Distribution:50% for Golden PASS holders, 50% for public sale</p></>
        }else{
            return <><p>Chain:Ethereum</p>
                <p>Rarity:Classic</p>
                <p>Total Supply:500</p>
                <p>Distribution:100% for Classic PASS holders</p></>
        }
    }

    changeAddr = (e: any) => {
        this.setState({
            address: e.target.value
        })
    }

    renderWhitelist = () => {
        const { whitelistList, isInWhiteList, activeMenu, nftTypeId, contractAddress, themeId, remainMintTokensNumber, quantity, userActionStatus, isClaimed } = this.state;
        const { web3Store } = this.props;
        const whitelistContent = (
            <ul>
                {whitelistList.map((item, index) => (
                    <li key={index}>{item}</li>))}
            </ul>
        )

        let userActionStatusResult= userActionStatus
        //服务端返回是否领取判断不准确，需要前端判断
        if (userActionStatus === UserActionStatus.WHITE_MODE_CLAIMED || userActionStatusResult === UserActionStatus.WHITE_MODE_CLAIMABLE) {
            if (isClaimed) {
                userActionStatusResult = UserActionStatus.WHITE_MODE_CLAIMED
            } else {
                userActionStatusResult = UserActionStatus.WHITE_MODE_CLAIMABLE
            }
        }
        let mintBtn;
        if (userActionStatusResult === UserActionStatus.WHITE_MODE_NO_ELIGIBLE) {//白名单模式未在白名单
            //在白名单地方处理
            mintBtn = <div className="text-center">
                <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                         contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
            </div>
        } else if (userActionStatusResult === UserActionStatus.WHITE_MODE_CLAIMABLE) {//白名单模式在白名单未领取
            //在白名单地方处理
            mintBtn = <div className="text-center">
                <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                         contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={false} />
            </div>
        } else if (userActionStatusResult === UserActionStatus.WHITE_MODE_CLAIMED) {//白名单模式在白名单且已领取
            //在在白名单地方处理
            mintBtn = <div className="text-center">
                <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claimed"}
                         contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={false} />
            </div>
        }else{
            mintBtn = <div className="text-center">
                <MintBtn web3Store={this.props.web3Store} activeMenu={activeMenu} nftTypeId={nftTypeId} btnContent={"Claim"}
                         contractAddress={contractAddress} themeId={themeId} mythNftWhiteList={whitelistList} isDisable={true} />
            </div>
        }
        return <><MythCard title={`${remainMintTokensNumber}/${quantity} for whitelist address`} className="holder-card"
            more={<Popover placement="left" title="Whitelist address" content={whitelistContent} trigger="hover">
                <i className="iconfont icon-reload"></i>
            </Popover>}>
            <ul>
                <li className="list-item flex-row space-between">
                    <span><CheckCircleFilled className="list-icon list-icon-success" />Connected ethereum wallet</span>
                    <Button className="myth-button myth-button-success">Connected</Button>
                </li>
                <li className="list-item flex-row">
                    <Input className="input-addr" value={web3Store.account} onChange={(e) => this.changeAddr(e)} />
                </li>
                <li className="list-item flex-row space-between">
                    {isInWhiteList ?
                        <span><CheckCircleFilled className="list-icon list-icon-success" />Congratulation! you are whitelisted</span> :
                        <span><CloseCircleFilled className="list-icon list-icon-danger" />Sorry! you are not whitelisted</span>}
                </li>
            </ul>
        </MythCard>
            <div className="text-center">
                {mintBtn}
            </div>
        </>
    }
    render() {
        const { activeMenu, actionId, themeName} = this.state;
        const { web3Store } = this.props;
        const { TabPane } = Tabs;
        if (!this.firstRequest) {
            this.requestActionInfo(actionId);
        }
        return <div>{!web3Store.account ? <div className="connect-margin"><NoConnectedWallet web3Store={web3Store}></NoConnectedWallet></div> :
            !this.firstRequest ? <div style={{ textAlign: "center", marginTop: "23%" }}>
                <Spin size="large" style={{ verticalAlign: "middle" }} />
            </div> : <div className="myth-panel free-mint-container">
                <div className="flex-row mint-main">
                    <div className="left-content">
                        <div className="mint-title flex-row space-between"><span className="content-title title-text">{activeMenu.actionName}</span>
                            {activeMenu.status === ActionStatus.ACTION_STATUS_UNSTARTED ? <span className={`myth-tag myth-tag-warning`}>upcoming</span> :
                                activeMenu.status === ActionStatus.ACTION_STATUS_EXPIRED ? <span className={`myth-tag myth-tag-danger`}>ended</span> :
                                    <span className={`myth-tag myth-tag-success`}>active</span>}
                        </div>
                        {this.renderRequirements()}
                        {this.renderPeriod()}
                        {activeMenu.actionType !== MythActionType.TYPE_WHITE && this.renderPassHolder()}
                        {activeMenu.actionType === MythActionType.TYPE_GOLDEN && this.renderPublicSale()}
                        {activeMenu.actionType === MythActionType.TYPE_WHITE && this.renderWhitelist()}
                    </div>
                    <div className="right-content">
                        <img src={activeMenu.actionImageUrl} alt="" />
                    </div>
                </div>
                <div className="flex-row mint-info">
                    <div className="left-content">
                        <div className="content-title title-text">{themeName}</div>
                        <div className="share-container">
                            <span onClick={this.gotoContract}>Contract <i className="iconfont icon-fenxiang"></i></span>
                            <span onClick={this.gotoMarket}>Marketplace <i className="iconfont icon-fenxiang"></i></span>
                        </div>
                        <div className="desc">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat hic voluptatem exercitationem. In minima hic est nisi corporis, tempora quibusdam impedit porro voluptates nam at sed repudiandae quod aliquid optio!
                        </div>
                    </div>
                    <div className="right-content">
                        <Tabs defaultActiveKey="2" className="mint-tabs myth-tabs">
                            <TabPane tab="NFT info" key="1">
                                {this.renderNFTINFO()}
                            </TabPane>
                            {/*<TabPane tab="Back story" key="2">
                                <MythCard title="Supply and distribution">
                                    <>
                                        <p>Classic500 is all distributed to Classic PASS holders.</p>
                                        <p> Classic500 is all distributed to Classic PASS holders.</p>
                                    </>
                                </MythCard>
                            </TabPane>*/}
                            <TabPane tab="Attention" key="3">
                                <p style={{textIndent:2}}>1. You can apply for minting the NFTs on the list for free by verifying your Myth PASS. When the countdown is over, we will announce the winners that will be able to mint for free on the Myth website. You can use your Myth PASS unlimited times, but if you withdraw it when you are on the waitlist, you will not be qualified for free mint.</p>
                                <p>2. To avoid the gas fee fluctuations on Ethereum, we have set aside 3 days for the selected applicants to claim their free NFTs. If the NFTs are not claimed in time, they will be taken back and you will lose the opportunity.</p>
                                <p>3. Classic NFTs can be applied for minting by verifying either Classic PASS or Golden PASS. Golden PASS will raise the success rate of being selected by 500%. Golden NFTs can only be applied for minting by verifying Golden PASS.</p>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        }
            {this.renderResult()}
        </div>
    }
}
export default withRouter(FreeMintPage);
